import { GroupWork as ConsolidatedIcon, ArrowForward as RightArrowIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { compose } from 'recompose';

import { WithStyles, withStyles } from '@/hocs/with-styles';

interface Props {}
const styles = (theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    flexDirection: 'column',
  },
  message: {
    paddingBottom: theme.spacing(2),
    maxWidth: '300px',
  },
  icon: {
    height: '100px',
    width: '100px',
    paddingBottom: theme.spacing(2),
  },
});
class NoGroupSelected extends React.Component<Props & WithStyles<typeof styles> & WithTranslation, {}> {
  public render() {
    const { t, classes } = this.props;
    return (
      <div className={classes.container}>
        <ConsolidatedIcon className={classes.icon} />
        <Typography variant="h6" className={classes.message}>
          {t(['line:noGroupSelected'], { defaultValue: 'No group selected' })}
        </Typography>
        <Typography align="center" variant="subtitle1" className={classes.message}>
          {t(['line:selectAGroupToSeeConsolidatedOee'], {
            defaultValue: 'Select a group in the menu to the right to see consolidated OEE',
          })}
        </Typography>
        <RightArrowIcon fontSize="large" />
      </div>
    );
  }
}
const enhance = compose<unknown, Props>(withTranslation(['shared', 'line']), withStyles(styles));
export default enhance(NoGroupSelected as React.ComponentType<unknown>);
